module.exports = __webpack_public_path__ + "img/park.42e61e82.jpg";